import { EvidencePolicies, OptionalChecks } from "@amber/evidence/ui";
import { ChecksHeader, RuleValues } from "@amber/operations/ui";

export function ChecksAndPolicies() {
  return (
    <section aria-labelledby="section-title" className="flex min-h-0 flex-1 flex-col overflow-auto">
      <ChecksHeader />
      <OptionalChecks />
      <EvidencePolicies />
      <RuleValues />
    </section>
  );
}
